<template>
    <div class="timelimit" v-loading="loading">
        <div class="timelimit-first">
            <div class="timelimit-first-top">
                <div class="timelimit-first-top-left">限时秒杀活动设置</div>
                <div class="timelimit-first-top-right" @click="refresh">刷新</div>
            </div>

            <div class="timelimit-first-table">
                <el-table :data="firstTable" border style="width: 100%; cursor: pointer" :header-cell-style="{
                    color: '#333333',
                    backgroundColor: '#FAFAFA',
                }">
                    <el-table-column label="秒杀日期开始">
                        <template slot-scope="scope">
                            <div v-html="scope.row.killStartTime"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="秒杀日期结束">
                        <template slot-scope="scope">
                            <div v-html="scope.row.killEndTime"></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否启用" width="200">
                        <template slot-scope="">
                            <div class="table-status">
                                <el-switch :value="activityStatus" active-color="#13ce66" inactive-color="#D9D9D9"
                                    @change="timelimitChange">
                                </el-switch>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <div class="table-operate" :style="{ color: activityStatus == true ? '#cccccc' : '' }"
                                @click="weifareActBtn(scope.row)">
                                编辑
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <div class="timelimit-second">
            <div class="timelimit-second-top">
                <div class="timelimit-second-top-display">
                    <div class="display-left">
                        <div class="display-left-commodity">
                            <div class="commodity-title">商品名称</div>
                            <div class="commodity-input">
                                <el-input placeholder="请输入商品名称" v-model="commodityName" clearable>
                                </el-input>
                            </div>
                        </div>

                        <div class="display-left-hit">
                            <div class="hit-query" @click="getTimeseckillClick">查询</div>
                            <div class="hit-reset" @click="Valuereset">重置</div>
                        </div>
                    </div>
                    <div class="display-right">
                        <div class="display-right-block" @click="addition">
                            <img class="display-right-img" src="../../assets/common/common-add.png" />
                            <div class="display-right-text">商品添加</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="timelimit-second-table">
                <el-table :data="tableData" border style="width: 100%; cursor: pointer" :header-cell-style="{
                    color: '#333333',
                    backgroundColor: '#FAFAFA',
                }">
                    <!-- 自定义暂无数据 -->
                    <template slot="empty">
                        <div class="empty-block">
                            <img class="empty-block-img" src="../../assets/common/common-empty.png" />
                            <div class="empty-block-text">暂无数据～</div>
                        </div>
                    </template>

                    <el-table-column prop="name" label="商品名称"> </el-table-column>
                    <el-table-column label="商品图片" width="234">
                        <template slot-scope="scope">
                            <img class="table-imgs" :src="scope.row.image" alt="" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="price" label="秒杀价(元)" width="136">
                    </el-table-column>
                    <el-table-column label="id限购数" width="144">
                        <template slot-scope="scope"> {{ scope.row.idNum }}次 </template>
                    </el-table-column>
                    <el-table-column prop="sort" label="排序" width="180">
                        <template slot-scope="scope">
                            <div class="table-sort" @click="sortBtn(scope.row)">
                                <!-- <img
                  class="table-sort-left"
                  :src="
                    scope.row.killIndex == 1
                      ? require('../../assets/marketing/marketing-top.png')
                      : require('../../assets/marketing/marketing-no.png')
                  "
                  alt=""
                /> -->
                                <img class="table-sort-left" src="../../assets/marketing/marketing-no.png" alt="" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180">
                        <template slot-scope="scope">
                            <div class="operation">
                                <!-- <div class="compile" @click="compileBtn(scope.row)">编辑</div> -->

                                <div class="delete" @click="deleteBtn(scope.row)">删除</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="timelimit-second-Pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="prev, pager, next, sizes" :total="totalNum">
                </el-pagination>
            </div>
        </div>

        <!-- 第一区域 编辑 -->
        <div class="redact">
            <el-dialog :visible.sync="redactDialogVisible" style="margin-top: 15vh" :show-close="false" @close="resetBtn">
                <span slot="footer" class="dialog-footer">
                    <div class="redact-div">
                        <div class="redact-div-top">
                            <div class="block-top-title">秒杀时间限制</div>
                            <img class="block-top-close" src="../../assets/common/close.png" @click="resetBtn" />
                        </div>

                        <div class="redact-div-center">
                            <div class="center-input">
                                <el-date-picker v-model="seckilTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                                    range-separator="" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="redact-div-button">
                            <!-- <div class="button-reset" @click="resetBtn">重 置</div> -->
                            <div class="button-confirm" @click="confirmBtn">确 定</div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>

        <!--switch状态开启关闭-->
        <div class="switch">
            <el-dialog :visible.sync="switchDialogVisible" width="394px" style="margin-top: 10vh" @close="switchClose">
                <span slot="footer" class="dialog-footer">
                    <div class="switch-div">
                        <img class="switch-div-img" src="../../assets/common/common-warning.png" />
                        <div class="switch-div-title">
                            {{
                                activityStatus == false
                                ? '是否确定开启此活动？'
                                : '是否确定关闭此活动？'
                            }}
                        </div>
                        <div class="switch-div-text">
                            {{
                                activityStatus == false
                                ? '一旦成功启用此活动，用户可参与此项活动。'
                                : '一旦关闭成功则用户不可参与此活动。'
                            }}
                        </div>
                        <div class="switch-div-button">
                            <div class="switch-div-button-left" @click="swicthBtn">确定</div>
                            <div class="switch-div-button-right" @click="switchClose">
                                取消
                            </div>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>

        <!-- 第二区域 添加模块 弹出框 -->
        <div class="addition">
            <el-dialog :visible.sync="additionDialogVisible" style="margin-top: 10vh" @close="additionReset(0)">
                <span slot="footer" class="dialog-footer">
                    <div class="addition-div">
                        <div class="addition-div-top">
                            <div class="addition-div-top-title">商品添加</div>
                            <img class="addition-div-top-img" src="../../assets/common/close.png"
                                @click="additionReset(0)" />
                        </div>

                        <div class="addition-div-center">
                            <div class="addition-div-center-title">商品名称</div>
                            <div class="addition-div-center-input">
                                <el-autocomplete class="inline-input" v-model="suggestValue"
                                    :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="false"
                                    @select="handleSelect" clearable></el-autocomplete>
                            </div>

                            <div class="addition-div-center-display">
                                <div class="display-left">
                                    <div class="display-left-title">商品id</div>
                                    <div class="display-left-select">
                                        <el-input placeholder="请输入商品id" v-model="additioncommondityId"
                                            class="input-with-select" :disabled="true"></el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="addition-div-center-display">
                                <div class="display-right" style="margin-left: 0px">
                                    <div class="display-right-title">id限购数</div>
                                    <div class="display-right-input">
                                        <el-input placeholder="请输入奖品成本" v-model="additionLimitationNum"
                                            class="input-with-select">
                                            <div class="input-append" slot="append">次</div>
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="addition-div-button">
                            <!-- <div class="button-reset" @click="additionReset(0)">重置</div> -->
                            <div class="button-confirm" @click="additionConfirm(0)">确定</div>
                        </div>
                    </div>
                </span></el-dialog>
        </div>

        <!--第二区域  商品编辑-->
        <div class="commodityedit">
            <el-dialog :visible.sync="editDialogVisible" style="margin-top: 10vh" @close="additionReset(1)">
                <span slot="footer" class="dialog-footer">
                    <div class="commodityedit-div">
                        <div class="commodityedit-div-top">
                            <div class="commodityedit-div-top-title">商品编辑</div>
                            <img class="commodityedit-div-top-img" src="../../assets/common/close.png"
                                @click="additionReset(1)" />
                        </div>

                        <div class="commodityedit-div-center">
                            <div class="commodityedit-div-center-title">商品名称</div>
                            <div class="commodityedit-div-center-input">
                                <el-autocomplete class="inline-input" v-model="editcommondName"
                                    :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="false"
                                    @select="handleSelect" clearable></el-autocomplete>
                            </div>

                            <div class="commodityedit-div-center-display">
                                <div class="display-left">
                                    <div class="display-left-title">商品id</div>
                                    <div class="display-left-select">
                                        <el-input placeholder="请输入商品id" v-model="editcommondId" class="input-with-select"
                                            :disabled="true"></el-input>
                                    </div>
                                </div>
                            </div>

                            <div class="commodityedit-div-center-display">
                                <div class="display-right" style="margin-left: 0px">
                                    <div class="display-right-title">id限购数</div>
                                    <div class="display-right-input">
                                        <el-input placeholder="请输入奖品成本" v-model="editLimitationNum"
                                            class="input-with-select">
                                            <div class="input-append" slot="append">次</div>
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="commodityedit-div-button">
                            <!-- <div class="button-reset" @click="additionReset(1)">重置</div> -->
                            <div class="button-confirm" @click="additionConfirm(1)">确定</div>
                        </div>
                    </div>
                </span></el-dialog>
        </div>

        <!--第二区域  商品删除-->
        <div class="commodityDetele">
            <el-dialog :visible.sync="deteleDialogVisible" style="margin-top: 10vh" @close="deteleConcat">
                <span slot="footer" class="dialog-footer">
                    <div class="commodityDetele-div">
                        <img class="commodityDetele-div-img" src="../../assets/common/common-warning.png" />
                        <div class="commodityDetele-div-title">
                            是否确定删除该活动商品？
                        </div>
                        <div class="commodityDetele-div-button">
                            <div class="commodityDetele-div-button-left" @click="deteleConfrom">
                                确定
                            </div>
                            <div class="commodityDetele-div-button-right" @click="deteleConcat">
                                取消
                            </div>
                        </div>
                    </div>
                </span></el-dialog>
        </div>
    </div>
</template>

<script>
import {
    getTimeseckill,
    postTimeseckillRule,
    putTimeseckillDisable,
    postTimeseckillAdd,
    deletefnTimeseckillDetele,
    putTimeseckill,
} from '../../api/activities'

import { getMarketList } from '../../api/commodity'

export default {
    data() {
        return {
            // 第一区域 活动是否开启状态 false 关闭 true 开启
            activityStatus: false,
            // 第一区域 活动是否开启弹窗 false 关闭 true 开启
            switchDialogVisible: false,
            // 第一区域 数组
            firstTable: [],
            // 编辑 弹出框
            redactDialogVisible: false,
            // 添加时间秒杀 数组
            seckilTime: [],
            // 添加时间秒杀
            seckilTimeA: '',
            // 添加时间秒杀
            seckilTimeB: '',
            // 第二区域 商品名称
            commodityName: '',
            // 第二区域 表格区域
            tableData: [],
            // 第二区域 添加弹出框  是否开启
            additionDialogVisible: false,
            // 添加弹出框  带建议搜索框数组
            restaurant: [],
            // 添加弹出框  商品搜索存储
            suggestValue: '',
            // 添加弹出框 选中
            additioncommondityId: '',
            // 添加弹出框 秒杀价
            seckillPrice: '',
            // 添加弹出框 秒杀时间
            additionSeckillTime: [],
            // 用户时间输入框的时候起始值
            additionSeckillTimeA: '',
            // 用户时间输入框的时候结尾值
            additionSeckillTimeB: '',
            // 添加弹出框 id限购数
            additionLimitationNum: '',

            // 商品编辑弹出框模块
            // 商品编辑弹出框 是否开启
            editDialogVisible: false,
            // 商品编辑弹出框 商品名称
            editcommondName: '',
            // 商品编辑弹出框 商品id
            editcommondId: '',
            // 编辑弹出框 秒杀时间
            editSeckillTime: [],
            // 用户时间输入框的时候起始值
            editSeckillTimeA: '',
            // 用户时间输入框的时候结尾值
            editSeckillTimeB: '',
            // 编辑弹出框 id限购数
            editLimitationNum: '',

            // 删除弹出框开启
            deteleDialogVisible: false,
            // 删除弹出框id
            deteleId: '',
            // 页码
            page: 1,
            // 页数
            limit: 10,
            // 总条数
            totalNum: 0,
            // 监听用户刷新
            loading: false,
            // 控制当前页面功能性按钮开关
            activeiesFunShow: false,
        }
    },
    created() {
        this.loading = true
        this.getTimeseckillClick()

        setTimeout(() => {
            this.activeiesFunShow = this.$store.state.pageFunctionShow
        }, 1000);
    },
    methods: {
        // 获取限时秒杀 基本数据
        getTimeseckillClick() {
            let params = {
                goodsName: this.commodityName,
                pageSize: this.limit,
                pageNo: this.page,
            }

            getTimeseckill(params).then((res) => {
                if (res.resultStatus == true) {
                    this.firstTable = []
                    // 获取表格数据
                    this.tableData = res.resultData.killList
                    // 获取总条数
                    this.totalNum - res.resultData.totalNum
                    // 第一区域数据
                    let obj = {
                        killEndTime: res.resultData.killEndTime,
                        killStartTime: res.resultData.killStartTime,
                    }

                    this.firstTable.push(obj)

                    // 秒杀日期是否开启
                    let Obj = res.resultData
                    this.activityStatus = Obj.status == 0 ? false : true

                    this.loading = false
                }
            })
        },

        // 第一区域点击修改输入框
        Valuereset() {
            this.commodityName = ''
            this.getTimeseckillClick()
        },
        // 商品区域 排序
        sortBtn(item) {
            if (this.activeiesFunShow == false) {
                return
            }
            console.log(item)
            let params = item.id
            putTimeseckill(params).then((res) => {
                console.log('获取对应的额params', res)
                if (res.resultStatus == true) {
                    this.loading = true
                    this.$message({
                        message: '置顶成功',
                        type: 'success',
                    })
                    this.getTimeseckillClick()
                }
            })
        },

        // 第一区域 修改状态
        timelimitChange() {
            if (this.activeiesFunShow == false) {
                return
            }

            this.switchDialogVisible = true
        },
        // 第一区域 监听switch的状态切换 确认
        swicthBtn() {
            console.log('点击确认', this.firstTable[0].killStartTime)

            if (
                this.firstTable[0].killStartTime == '' ||
                this.firstTable[0].killEndTime == ''
            ) {
                return
            }

            if (this.activityStatus == false) {
                // 获取当前时间戳
                let time = parseInt(new Date().getTime() / 1000) + ''
                // 获取当前点击开启秒杀活动的时间

                console.log('开启活动', this.firstTable[0].killStartTime)
                // 开启时间
                let timeA =
                    parseInt(
                        new Date(this.firstTable[0].killStartTime).getTime() / 1000
                    ) + ''
                let timeB =
                    parseInt(new Date(this.firstTable[0].killEndTime).getTime() / 1000) +
                    ''

                // 当天时间＜秒杀开始日期＜秒杀结束日期

                if (time < timeA && timeA < timeB) {
                    this.disableClick()
                } else {
                    this.switchDialogVisible = false
                    this.$message({
                        message:
                            '当前活动时间要大于活动开启时开始的时间、结束活动的时间要大于开启活动的时间',
                        type: 'error',
                        duration: 1000,
                    })
                }
            } else {
                // 关闭活动的时候是不需要任何判断条件
                this.disableClick()
            }
        },

        // 开启关闭接口逻辑
        disableClick() {
            let params = {}
            putTimeseckillDisable(params).then((res) => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: this.activityStatus == false ? '启动成功' : '禁用成功',
                        type: 'success',
                    })

                    this.activityStatus = !this.activityStatus
                    this.switchDialogVisible = false
                    this.getTimeseckillClick()
                }
            })
        },
        // 第一区域 监听switch的状态切换 取消
        switchClose() {
            this.switchDialogVisible = false
        },
        // 第二区域 弹出框 添加
        addition() {
            if (this.activeiesFunShow == false) {
                return
            }
            this.seckillPrice = ''
            // 添加弹出框 秒杀时间
            this.additionSeckillTime = ''
            // 添加弹出框 id限购数
            this.additionLimitation = ''
            this.additionDialogVisible = true
        },

        // 第二区域 添加 重置 取消按钮
        additionReset() {
            this.additionDialogVisible = false
            this.editDialogVisible = false
        },
        // 第二区域 添加 确定 确认按钮
        additionConfirm(index) {
            let params = {}

            if (index == 0) {
                params = {
                    id: this.additioncommondityId,
                    idNum: this.additionLimitationNum,
                }
            } else {
                params = {
                    id: this.editcommondId,
                    idNum: this.editLimitationNum,
                }
            }
            postTimeseckillAdd(params).then((res) => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: index == 0 ? '添加成功！' : '修改成功！',
                        type: 'success',
                        duration: 2000,
                    })
                    this.loading = true
                    this.suggestValue = ''
                    this.additioncommondityId = ''
                    this.additionSeckillTime = []
                    this.additionLimitationNum = ''

                    this.editcommondName = ''
                    this.editcommondId = ''
                    this.editSeckillTime = []
                    this.editLimitationNum = ''

                    this.additionDialogVisible = false
                    this.editDialogVisible = false
                    this.getTimeseckillClick()
                } else {
                    //   this.$message({
                    //     message: res.errorMessage,
                    //     type: 'error',
                    //     duration: 2000,
                    //   })
                    this.loading = true
                    this.suggestValue = ''
                    this.additioncommondityId = ''
                    this.additionSeckillTime = []
                    this.additionLimitationNum = ''

                    this.editcommondName = ''
                    this.editcommondId = ''
                    this.editSeckillTime = []
                    this.editLimitationNum = ''

                    this.additionDialogVisible = false
                    this.editDialogVisible = false
                    this.getTimeseckillClick()
                }
            })
        },

        // 用户点击界面刷新
        refresh() {
            this.loading = true

            this.$nextTick(() => {
                this.getTimeseckillClick()
            })
        },

        // 第一区域 点击操作编辑
        weifareActBtn(item) {
            if (this.activeiesFunShow == false) {
                return
            }

            if (this.activityStatus == true) {
                return
            }

            console.log(item)

            this.seckilTime = [item.killStartTime, item.killEndTime]

            this.redactDialogVisible = true
        },

        // 第一区域 编辑弹出框 重置
        resetBtn() {
            this.redactDialogVisible = false
        },
        // 第一区域 编辑弹出框 确定
        confirmBtn() {
            if (this.seckilTime != null) {
                this.seckilTimeA = this.seckilTime[0]
                this.seckilTimeB = this.seckilTime[1]
            } else {
                this.seckilTimeA = ''
                this.seckilTimeB = ''
            }

            console.log('确定')
            // 获取当前时间戳
            let time = parseInt(new Date().getTime() / 1000) + ''
            // 获取当前点击开启秒杀活动的时间

            console.log('开启活动', this.seckilTimeA)
            // 开启时间
            let timeA = parseInt(new Date(this.seckilTimeA).getTime() / 1000) + ''
            let timeB = parseInt(new Date(this.seckilTimeB).getTime() / 1000) + ''

            // 当天时间＜秒杀开始日期＜秒杀结束日期
            console.log('获取当前点击的时间', time)
            console.log('获取当前点击开启秒杀活动的时间', timeA)
            console.log('获取当前点击结束秒杀活动的时间', timeB)

            if (time < timeA && timeA < timeB) {
                let params = {
                    detail: '',
                    killStartTime: this.seckilTimeA,
                    killEndTime: this.seckilTimeB,
                }

                postTimeseckillRule(params).then((res) => {
                    if (res.resultStatus == true) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success',
                            duration: 2000,
                        })

                        this.loading = true
                        this.seckilTime = []

                        this.redactDialogVisible = false
                        this.getTimeseckillClick()
                    }
                })
            } else {
                this.$message({
                    message:
                        '当前点击确定的保存时间要大于开启活动的时间、结束活动的时间要大于开启活动的时间',
                    type: 'error',
                    duration: 2000,
                })
            }
        },

        // end

        // 第二区域 商品列表 编辑弹出框
        compileBtn(item) {
            if (this.activeiesFunShow == false) {
                return
            }

            console.log('点击编辑弹出框', item)
            // 商品名称
            this.editcommondName = item.name
            // 商品id
            this.editcommondId = item.id
            // 时间
            this.editSeckillTime = [item.killStartTime, item.killEndTime]
            // this.$set(this.editSeckillTime, '', [item.killStartTime, item.killEndTime])
            // 限购次数
            this.editLimitationNum = item.idNum

            this.editDialogVisible = true
        },
        // end
        // 带建议搜索
        // 供应商带建议搜索
        querySearch(queryString, cb) {
            if (queryString == '') {
                cb(this.restaurant)
            } else {
                let params = {
                    id: '', // 商品id
                    name: this.suggestValue, // 商品名称
                    code: '', // 商品编号
                    chandi: '', // 产地
                    is_speciality: '', // 是否为特产  1是
                    is_handpick: '', // 是否精选 1是
                    goods_one_type_id: '', // 一级分类id
                    goods_two_type_id: '', // 二级分类id
                    supplier_name: '', // 供应商名称
                    brand_name: '', // 品牌名称
                    status: 2, // 状态:1=上架,2=下架 30活动中
                    pageSize: 99999999, // 页码
                    pageNo: 1, // 页数
                }

                getMarketList(params, { condition: queryString }).then((res) => {
                    if (res.resultStatus == true) {
                        this.restaurant = res.resultData.goodsList
                        //这个插件只能过滤key为value得值.所以要把获取到得后台字段给重新赋值为value
                        res.resultData.goodsList.map((item) => {
                            item.value = item.name
                            return item
                        })

                        cb(res.resultData.goodsList)
                    }
                })
            }
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (
                    restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
                    0
                )
            }
        },
        loadAll() {
            return this.restaurant
        },
        handleSelect(item) {
            this.additioncommondityId = item.id
        },

        // 第二区域 商品列表 删除弹出框
        deleteBtn(item) {
            if (this.activeiesFunShow == false) {
                return
            }
            this.deteleId = item.id
            this.deteleDialogVisible = true
        },
        // 删除弹出框 确认
        deteleConfrom() {
            let params = this.deteleId

            deletefnTimeseckillDetele(params).then((res) => {
                if (res.resultStatus == true) {
                    this.$message({
                        message: '删除成功！',
                        type: 'success',
                        duration: 2000,
                    })
                    this.loading = true
                    this.commodityName = ''
                    this.deteleId = ''
                    this.deteleDialogVisible = false
                    this.getTimeseckillClick()
                }
            })
        },
        // 删除弹出框 取消
        deteleConcat() {
            this.deteleDialogVisible = false
        },

        // 查询当前页码多少条
        handleSizeChange(val) {
            this.limit = val
            this.loading = true
            console.log(`每页 ${val} 条`)
            this.getTimeseckillClick()
        },
        // 查询当前页
        handleCurrentChange(val) {
            this.page = val
            this.loading = true
            console.log(`当前页: ${val}`)
            this.getTimeseckillClick()
        },
    },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
    border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: rgba(255, 255, 255, 0);
}

.timelimit {
    .timelimit-first {
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px #edeff7;
        border-radius: 10px;
        padding: 0 24px;
        padding-bottom: 24px;
        box-sizing: border-box;

        .timelimit-first-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 68px;

            .timelimit-first-top-left {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #222222;
            }

            .timelimit-first-top-right {
                width: 70px;
                height: 36px;
                border-radius: 10px;
                border: 1px solid rgba(34, 34, 34, 0.4);
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #222222;
                text-align: center;
                line-height: 36px;
                cursor: pointer;
            }
        }

        .timelimit-first-table {
            /deep/ .el-table thead {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #333333;
                background: #d8d8d8;
            }

            /deep/ .el-table tr {
                height: 46px;
            }

            .table-rule {
                word-break: break-all;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .table-status {
                width: 42px;
                height: 25px;

                /deep/ .el-switch__core {
                    width: 42px !important;
                }
            }

            .table-operate {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #2aa4ff;
                text-decoration: underline;
            }
        }
    }

    .timelimit-second {
        background: #ffffff;
        box-shadow: 0px 0px 10px 0px #edeff7;
        border-radius: 10px;
        padding: 24px;
        padding-bottom: 0;
        box-sizing: border-box;
        margin-top: 24px;

        .timelimit-second-top {
            height: 102px;

            .timelimit-second-top-display {
                display: flex;
                justify-content: space-between;
                align-items: self-end;

                .display-left {
                    display: flex;
                    align-items: self-end;

                    .display-left-commodity {
                        .commodity-title {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .commodity-input {
                            margin-top: 4px;
                            width: 330px;

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                background-color: rgba(255, 255, 255, 0);
                            }
                        }
                    }

                    .display-left-hit {
                        display: flex;
                        margin-left: 40px;

                        .hit-query,
                        .hit-reset {
                            width: 110px;
                            height: 36px;
                            background: #222222;
                            border-radius: 10px;
                            text-align: center;
                            line-height: 36px;
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #ffffff;
                            cursor: pointer;
                        }

                        .hit-reset {
                            background: #f4f5f9;
                            margin-left: 10px;
                            color: #999999;
                        }
                    }
                }

                .display-right {
                    display: flex;
                    align-items: self-end;

                    .display-right-status {
                        display: flex;

                        .status-text {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .status-div {
                            width: 42px;
                            height: 22px;
                            margin-left: 10px;

                            /deep/ .el-switch__core {
                                width: 42px !important;
                            }
                        }
                    }

                    .display-right-block {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 110px;
                        height: 36px;
                        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                        border-radius: 10px;
                        cursor: pointer;
                        margin-left: 56px;

                        .display-right-img {
                            width: 13px;
                            height: 13px;
                        }

                        .display-right-text {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #ffffff;
                            margin-left: 8px;
                        }
                    }
                }
            }
        }

        .timelimit-second-table {
            /deep/ .el-table .el-table__cell {
                padding: 13px 0;
                vertical-align: top;
            }

            /deep/ .el-table thead {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #333333;
                background: #d8d8d8;
            }

            /deep/ .el-table tr {
                height: 46px;
            }

            /deep/ .el-table__empty-text {
                line-height: 0;
            }

            .empty-block {
                margin-top: 62px;
                padding-bottom: 40px;

                .empty-block-img {
                    width: 130px;
                    height: 130px;
                    margin: 0 auto;
                }

                .empty-block-text {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    margin-top: 10px;
                    height: 17px;
                    line-height: 17px;
                }
            }

            .table-imgs {
                width: 120px;
                height: 70px;
            }

            .table-sort {
                display: flex;

                .table-sort-left,
                .table-sort-right {
                    width: 23px;
                    height: 23px;
                }

                .table-sort-right {
                    margin-left: 4px;
                }
            }

            .operation {
                display: flex;

                .compile,
                .delete {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #2aa4ff;
                    text-decoration: underline;
                }
            }
        }

        .timelimit-second-Pagination {
            height: 88px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            /deep/ .el-pagination .btn-prev {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                margin-right: 8px;
            }

            /deep/ .el-pagination .btn-next {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
            }

            /deep/ .el-pager li {
                padding: 0;
                width: 32px;
                height: 32px;
                background: #ffffff;
                border-radius: 2px;
                border: 1px solid #d9d9d9;
                line-height: 32px;
                margin-right: 8px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }

            /deep/ .el-pager li.active {
                background: #000000;
                color: #ffffff;
            }

            /deep/ .el-input--mini .el-input__inner {
                height: 32px;
            }

            /deep/ .el-input__inner {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
            }
        }
    }

    /* 弹出框 */
    .redact {
        /deep/ .el-dialog {
            width: 444px;
            height: 212px;
            background: #ffffff;
            box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
                0px 9px 28px 0px rgba(0, 0, 0, 0.05),
                0px 6px 16px -8px rgba(0, 0, 0, 0.08);
            border-radius: 10px;
        }

        /deep/ .el-dialog__footer {
            padding: 0;
            text-align: left;
        }

        .redact-div {
            .redact-div-top {
                display: flex;
                height: 56px;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;
                box-sizing: border-box;
                border-bottom: 1px solid #e9edf4;

                .block-top-title {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #222222;
                }

                .block-top-close {
                    width: 10px;
                    height: 10px;
                    cursor: pointer;
                }
            }

            .redact-div-center {
                padding: 0 24px;
                box-sizing: border-box;
                margin-top: 20px;

                .center-display {
                    display: flex;
                    margin-top: 14px;

                    .center-display-left,
                    .center-display-right {
                        width: 180px;

                        .center-display-left-title,
                        .center-display-right-title {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .center-display-left-picker,
                        .center-display-right-picker {
                            width: 180px;
                            margin-top: 4px;

                            /deep/ .el-date-editor.el-input {
                                width: 100%;
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                height: 32px;
                            }

                            /deep/ .el-input__icon {
                                line-height: 0.17rem;
                            }
                        }
                    }

                    .center-display-right {
                        margin-left: 36px;
                    }
                }
            }

            .redact-div-button {
                width: 100%;
                height: 52px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 0 24px;
                box-sizing: border-box;
                border-top: 1px solid #d9d9d9;
                margin-top: 28px;

                .button-reset,
                .button-confirm {
                    width: 65px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #e9edf4;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }

                .button-confirm {
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    color: #ffffff;
                    margin-left: 8px;
                }
            }
        }
    }

    /* 添加弹出框 */
    .addition {
        /deep/ .el-dialog {
            width: 444px;
            height: 340px;
            background: #ffffff;
            box-shadow: 0px 12px 48px 16px rrgba(134, 77, 77, 0.03) 0px 9px 28px 0px rgba(0, 0, 0, 0.05),
                0px 6px 16px -8px rgba(0, 0, 0, 0.08);
            border-radius: 10px;
        }

        /deep/ .el-dialog__footer {
            padding: 0;
            text-align: left;
        }

        .addition-div {
            .addition-div-top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 56px;
                padding: 0 24px;
                box-sizing: border-box;
                border-bottom: 1px solid #d9d9d9;

                .addition-div-top-title {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #222222;
                }

                .addition-div-top-img {
                    width: 10px;
                    height: 10px;
                }
            }

            .addition-div-center {
                padding: 0 24px;
                box-sizing: border-box;
                margin-top: 20px;

                .addition-div-center-title {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }

                .addition-div-center-input {
                    margin-top: 4px;
                    width: 100%;

                    /deep/ .el-autocomplete {
                        width: 100%;
                    }

                    /deep/ .el-input {
                        width: 100%;
                        height: 32px;
                    }

                    /deep/ .el-input__inner {
                        width: 100%;
                        padding: 0 10px;
                        box-sizing: border-box;
                        height: 32px;
                        background-color: rgba(255, 255, 255, 0);
                    }
                }

                .addition-div-center-display {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 14px;

                    .display-left {
                        width: 100%;

                        .display-left-title {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .display-left-select {
                            margin-top: 4px;
                            width: 100%;
                            height: 32px;

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                background-color: rgba(255, 255, 255, 0);
                            }
                        }

                        .display-left-input {
                            width: 100%;
                            margin-top: 4px;

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                width: 100%;
                                background-color: rgba(255, 255, 255, 0);
                            }

                            /deep/ .el-input-group__append {
                                background-color: #ffffff;
                                height: 32px;
                                padding: 0;
                            }

                            .input-append {
                                width: 38px;
                                height: 30px;
                                background: #ffffff;
                                border-radius: 0px 5px 5px 0px;
                                text-align: center;
                                line-height: 32px;
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #555555;
                            }
                        }
                    }

                    .display-right {
                        .display-right-title {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .display-right-input {
                            width: 180px;
                            margin-top: 4px;

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                background-color: rgba(255, 255, 255, 0);
                            }

                            /deep/ .el-input-group__append {
                                background-color: #ffffff;
                                height: 32px;
                                padding: 0;
                            }

                            .input-append {
                                width: 38px;
                                height: 30px;
                                background: #ffffff;
                                border-radius: 0px 5px 5px 0px;
                                text-align: center;
                                line-height: 32px;
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #555555;
                            }
                        }
                    }
                }
            }

            .addition-div-button {
                margin-top: 24px;
                height: 52px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 0 24px;
                box-sizing: border-box;
                border-top: 1px solid #d9d9d9;

                .button-reset,
                .button-confirm {
                    width: 65px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #e9edf4;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }

                .button-confirm {
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    color: #ffffff;
                    margin-left: 8px;
                }
            }
        }
    }

    /* 商品编辑 */
    .commodityedit {
        /deep/ .el-dialog {
            width: 444px;
            height: 340px;
            background: #ffffff;
            box-shadow: 0px 12px 48px 16px rrgba(134, 77, 77, 0.03) 0px 9px 28px 0px rgba(0, 0, 0, 0.05),
                0px 6px 16px -8px rgba(0, 0, 0, 0.08);
            border-radius: 10px;
        }

        /deep/ .el-dialog__footer {
            padding: 0;
            text-align: left;
        }

        .commodityedit-div {
            .commodityedit-div-top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 56px;
                padding: 0 24px;
                box-sizing: border-box;
                border-bottom: 1px solid #d9d9d9;

                .commodityedit-div-top-title {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #222222;
                }

                .commodityedit-div-top-img {
                    width: 10px;
                    height: 10px;
                    cursor: pointer;
                }
            }

            .commodityedit-div-center {
                padding: 0 24px;
                box-sizing: border-box;
                margin-top: 20px;

                .commodityedit-div-center-title {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                }

                .commodityedit-div-center-input {
                    margin-top: 4px;
                    width: 100%;

                    /deep/ .el-autocomplete {
                        width: 100%;
                    }

                    /deep/ .el-input {
                        width: 100%;
                        height: 32px;
                    }

                    /deep/ .el-input__inner {
                        width: 100%;
                        padding: 0 10px;
                        box-sizing: border-box;
                        height: 32px;
                        background-color: rgba(255, 255, 255, 0);
                    }
                }

                .commodityedit-div-center-display {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 14px;

                    .display-left {
                        width: 100%;

                        .display-left-title {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .display-left-select {
                            margin-top: 4px;
                            width: 100%;
                            height: 32px;

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                width: 100%;
                                background-color: rgba(255, 255, 255, 0);
                            }
                        }

                        .display-left-input {
                            width: 100%;
                            margin-top: 4px;

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                width: 100%;
                                background-color: rgba(255, 255, 255, 0);
                            }

                            /deep/ .el-input-group__append {
                                background-color: #ffffff;
                                height: 32px;
                                padding: 0;
                            }

                            .input-append {
                                width: 38px;
                                height: 30px;
                                background: #ffffff;
                                border-radius: 0px 5px 5px 0px;
                                text-align: center;
                                line-height: 32px;
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #555555;
                            }
                        }
                    }

                    .display-right {
                        .display-right-title {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }

                        .display-right-input {
                            width: 180px;
                            margin-top: 4px;

                            /deep/ .el-input {
                                height: 32px;
                            }

                            /deep/ .el-input__inner {
                                padding: 0 10px;
                                box-sizing: border-box;
                                height: 32px;
                                background-color: rgba(255, 255, 255, 0);
                            }

                            /deep/ .el-input-group__append {
                                background-color: #ffffff;
                                height: 32px;
                                padding: 0;
                            }

                            .input-append {
                                width: 38px;
                                height: 30px;
                                background: #ffffff;
                                border-radius: 0px 5px 5px 0px;
                                text-align: center;
                                line-height: 32px;
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #555555;
                            }
                        }
                    }
                }
            }

            .commodityedit-div-button {
                margin-top: 24px;
                height: 52px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 0 24px;
                box-sizing: border-box;
                border-top: 1px solid #d9d9d9;

                .button-reset,
                .button-confirm {
                    width: 65px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #e9edf4;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }

                .button-confirm {
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    color: #ffffff;
                    margin-left: 8px;
                }
            }
        }
    }

    /* 商品删除 */
    .commodityDetele {
        /deep/ .el-dialog {
            height: 231px;
            width: 394px;
        }

        /deep/ .el-dialog__footer {
            padding: 25px 0;
            box-sizing: border-box;
        }

        .commodityDetele-div {
            width: 100%;
            text-align: center;

            .commodityDetele-div-img {
                width: 56px;
                height: 56px;
                margin: 0 auto;
            }

            .commodityDetele-div-title {
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                margin-top: 8px;
            }

            .commodityDetele-div-button {
                display: flex;
                justify-content: center;
                align-content: center;
                margin-top: 40px;

                .commodityDetele-div-button-left,
                .commodityDetele-div-button-right {
                    width: 88px;
                    height: 32px;
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    border-radius: 10px;
                    text-align: center;
                    line-height: 32px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    cursor: pointer;
                }

                .commodityDetele-div-button-right {
                    margin-left: 8px;
                    border: 1px solid #e9edf4;
                    color: rgba(0, 0, 0, 0.65);
                    background: #ffffff;
                }
            }
        }
    }

    /*活动开启 */
    .switch {
        /deep/ .el-dialog {
            height: 231px;
        }

        /deep/ .el-dialog__footer {
            padding: 25px 0;
            box-sizing: border-box;
        }

        .switch-div {
            width: 100%;
            text-align: center;

            .switch-div-img {
                width: 56px;
                height: 56px;
                margin: 0 auto;
            }

            .switch-div-title {
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.85);
                margin-top: 8px;
            }

            .switch-div-text {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.45);
                margin-top: 2px;
            }

            .switch-div-button {
                display: flex;
                justify-content: center;
                align-content: center;
                margin-top: 18px;

                .switch-div-button-left,
                .switch-div-button-right {
                    width: 88px;
                    height: 32px;
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    border-radius: 10px;
                    text-align: center;
                    line-height: 32px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #ffffff;
                    cursor: pointer;
                }

                .switch-div-button-right {
                    margin-left: 8px;
                    border: 1px solid #e9edf4;
                    color: rgba(0, 0, 0, 0.65);
                    background: #ffffff;
                }
            }
        }
    }

    /* 弹出框 */
    .redact {
        /deep/ .el-dialog {
            width: 444px;
            height: 186px;
            background: #ffffff;
            box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.03),
                0px 9px 28px 0px rgba(0, 0, 0, 0.05),
                0px 6px 16px -8px rgba(0, 0, 0, 0.08);
            border-radius: 10px;
        }

        /deep/ .el-dialog__footer {
            padding: 0;
            text-align: left;
        }

        .redact-div {
            .redact-div-top {
                display: flex;
                height: 56px;
                align-items: center;
                justify-content: space-between;
                padding: 0 24px;
                box-sizing: border-box;
                border-bottom: 1px solid #e9edf4;

                .block-top-title {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #222222;
                }

                .block-top-close {
                    width: 10px;
                    height: 10px;
                    cursor: pointer;
                }
            }

            .redact-div-center {
                padding: 0 24px;
                box-sizing: border-box;
                margin-top: 20px;

                .center-input {
                    width: 100%;
                    margin-top: 4px;

                    /deep/ .el-input {
                        height: 32px;
                    }

                    /deep/ .el-input__inner {
                        padding: 0 10px;
                        box-sizing: border-box;
                        height: 32px;
                        background-color: rgba(255, 255, 255, 0);
                    }

                    /deep/ .el-date-editor .el-range-separator {
                        width: 26px;
                        padding: 0;
                        height: 32px;
                        line-height: 32px;
                        background-image: url('../../assets/activities/activities-right.png');
                        background-repeat: no-repeat;
                        background-position: center;
                    }
                }
            }

            .redact-div-button {
                width: 100%;
                height: 52px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding: 0 16px;
                box-sizing: border-box;
                border-top: 1px solid #d9d9d9;
                margin-top: 25px;

                .button-reset,
                .button-confirm {
                    width: 65px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 10px;
                    border: 1px solid #e9edf4;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }

                .button-confirm {
                    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                    color: #ffffff;
                    margin-left: 8px;
                }
            }
        }
    }
}
</style>
